/**
 * Elite Prime horizontal “learn” chips — Asset Allocation + Re-Allocation articles.
 *
 * Belongs here: carousel chrome + static-site CTA handoff (placed under pricing philosophy).
 * Does not belong here: plus-banner / pricing-details sheet.
 */
import {
  ELITE_PLANS_LEARN_ASSET_ALLOCATION_ICON_SRC,
  ELITE_PLANS_LEARN_REALLOCATION_ICON_SRC
} from '../constants/assets'
import { ElitePlansEventId, trackElitePlansClick } from '../analytics'
import { ChevronRightIcon } from '../icons/ChevronRightIcon'
import { postCTA as postCta } from '../../../utils/appBridge'
import { getStaticSiteCta } from '../../../utils/commonAppCTAs'

const LEARN_CARDS = [
  {
    id: 'asset-allocation',
    title: 'Learn the importance of Asset Allocation',
    iconSrc: ELITE_PLANS_LEARN_ASSET_ALLOCATION_ICON_SRC,
    staticSiteType: 'ELITE_LANDING_ALLOCATION'
  },
  {
    id: 'reallocation',
    title: 'And the importance of Re-Allocation',
    iconSrc: ELITE_PLANS_LEARN_REALLOCATION_ICON_SRC,
    staticSiteType: 'ELITE_LANDING_REALLOCATION'
  }
] as const

export function ElitePlansPrimeLearnCarousel({ planId }: { planId: string }) {
  return (
    <div className='mt-3 w-full' aria-label='Learn about allocation'>
      <ul className='m-0 flex list-none snap-x snap-mandatory gap-3 overflow-x-auto overflow-y-hidden px-0 pb-1 no-scrollbar [scroll-padding-inline:0]'>
        {LEARN_CARDS.map((card) => (
          <li key={card.id} className='shrink-0 snap-start'>
            <LearnCarouselCard
              title={card.title}
              iconSrc={card.iconSrc}
              staticSiteType={card.staticSiteType}
              planId={planId}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

function LearnCarouselCard({
  title,
  iconSrc,
  staticSiteType,
  planId
}: {
  title: string
  iconSrc: string
  staticSiteType: string
  planId: string
}) {
  return (
    <button
      type='button'
      onClick={() => {
        trackElitePlansClick(ElitePlansEventId.ViewDetails, {
          planId,
          buttonLabel: title
        })
        postCta(JSON.stringify(getStaticSiteCta(staticSiteType)))
      }}
      className='ep-focus-ring flex w-[245px] items-center gap-4 rounded-xl border border-solid border-white bg-[#fcf1ed] px-3 py-[14px] text-left backdrop-blur-[17px]'
      aria-label={title}
    >
      <span className='flex min-w-0 flex-1 items-center gap-3'>
        <span className='flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-[7px] bg-[#ffd9cc]'>
          <img src={iconSrc} alt='' aria-hidden='true' width={17} height={17} className='size-[17px]' />
        </span>
        <span className='min-w-0 text-[13px] font-medium leading-[1.5] text-[#732e17]'>{title}</span>
      </span>
      <ChevronRightIcon size={12} color='#8e9393' className='shrink-0' />
    </button>
  )
}
